// @flow
import * as React from 'react';
import { first, noop } from 'lodash/fp';

import type { DeviceModel, DeviceType, Region } from '~/core/types/devices';

import DeviceListGroup from './group';
import DeviceListItem from './item';

type DevicePropsType = {
    id: string,
    field: any,
    props: {
        manufacturer?: string,
        model?: DeviceModel,
        online: boolean,
        capabilities?: Array<string>
    },
    type: DeviceType
};

type Props = {
    devices: Array<Array<DevicePropsType>>,
    localeSuffix: Region,
    identifyDevice: noop,
    isNano1: boolean
};

// $FlowFixMe
const DeviceList = ({ devices, localeSuffix, identifyDevice, isNano1 }: Props) => (
    <ul>
        {devices.map(
            deviceList =>
                deviceList.length === 1 ? (
                    deviceList.map(({ id, field, props, type }: DevicePropsType) => (
                        <li key={id}>
                            <DeviceListItem
                                capabilities={props.capabilities}
                                field={field}
                                id={id}
                                identifyDevice={identifyDevice}
                                isNano1={isNano1}
                                localeSuffix={localeSuffix}
                                manufacturer={props && props.manufacturer}
                                model={props && props.model}
                                online={props && props.online}
                                type={type}
                            />
                        </li>
                    ))
                ) : (
                    <li key={'device-group-' + first(deviceList).type}>
                        <DeviceListGroup
                            devices={deviceList}
                            identifyDevice={identifyDevice}
                            isNano1={isNano1}
                            localeSuffix={localeSuffix}
                            model={first(deviceList).props && first(deviceList).props.model}
                            type={first(deviceList).type}
                        />
                    </li>
                )
        )}
    </ul>
);

export default DeviceList;



// WEBPACK FOOTER //
// ./src/components/widgets/device-list/component.js